/**
 * This file is part of Discorch.
 * Copyright (C) 2025 Discorch Contributors.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import { ThemeToggle } from "@/components/ThemeToggle";

export function Header() {
  return (
    <header className="mx-auto mb-12 w-full max-w-4xl">
      <nav className="mb-8 flex items-center justify-end">
        <ThemeToggle />
      </nav>

      <div className="space-y-6 text-center">
        <h1 className="from-foreground to-foreground/70 bg-linear-to-br bg-clip-text text-4xl font-semibold tracking-tight text-transparent lg:text-5xl">
          Discorch
        </h1>

        <div className="space-y-2">
          <p className="text-foreground/90 text-lg">
            Take control of your Discord message history
          </p>
          <p className="text-muted-foreground mx-auto max-w-md text-base">
            Browse and archive your messages, and easily request deletions — all
            while respecting Discord's guidelines
          </p>
        </div>
      </div>
    </header>
  );
}
